import { type EntityEvent, EntityType } from '@racemap/sdk/schema/entityEvents';
import type { Starter } from '@racemap/sdk/schema/starters';
import { useEventStarter } from './useEventStarter';

// Custom hook to derive the starter for an alert
export function useAlertStarter(alert: EntityEvent, eventId: string): Starter | null {
  const deviceId =
    alert.entityType === EntityType.DEVICES ? alert.entityId.toHexString() : undefined;
  const starterId =
    alert.entityType === EntityType.STARTERS ? alert.entityId.toHexString() : undefined;
  const { starter: deviceStarter } = useEventStarter({ eventId, deviceId });
  const { starter } = useEventStarter({ eventId, id: starterId });
  return deviceStarter ?? starter;
}
